import GiftLandingPage from './GiftLandingPage';

export default GiftLandingPage;
